export default "__VITE_ASSET__DiE9R8gH__"